import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgForward = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M4.374 3.504a1.306 1.306 0 0 0-1.428-.078 1.4 1.4 0 0 0-.517.53c-.119.216-.179.459-.179.702v14.684M4.374 3.504l5.076 3.46V4.657c0-.243.06-.486.18-.702.119-.217.295-.402.516-.53a1.31 1.31 0 0 1 1.445.091l.005.003 9.595 7.34.003.001c.179.135.319.311.413.508a1.46 1.46 0 0 1 0 1.262 1.4 1.4 0 0 1-.413.508l-.003.002-9.6 7.342a1.306 1.306 0 0 1-1.445.091 1.4 1.4 0 0 1-.517-.53 1.46 1.46 0 0 1-.179-.702v-2.305l-5.076 3.459a1.306 1.306 0 0 1-1.428.078 1.4 1.4 0 0 1-.517-.53 1.46 1.46 0 0 1-.179-.702m1.5-14.448 6.028 4.108a.75.75 0 0 0 1.172-.62V4.915L20.214 12l-9.264 7.085v-3.467a.75.75 0 0 0-1.172-.62L3.75 19.106z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgForward;
